
import 'zone.js/dist/zone';  // Included with Angular CLI.
import '@angular/localize/init';